import { getItem, setItem } from '../local-storage-service';

type CustomerLike = {
    postal_code: string;
};
type InsuranceLike = {
    WOON: {
        address: {
            postalCode: string;
            houseNumber: string;
        };
        postal_code: string;
        civic_number: string;
    };
};
type AddressInfo = {
    postalCode: string;
    houseNumber: string;
};

const getAddressInfo = async () => {
    const customer = (await getItem('customer')) as CustomerLike;
    const insurance = (await getItem('insurances')) as InsuranceLike;

    return {
        postalCode: insurance?.WOON?.postal_code || customer?.postal_code,
        houseNumber: insurance?.WOON?.civic_number
    } as AddressInfo;
};

const setAddressInfo = async ({ postalCode, houseNumber }: AddressInfo) => {
    const customer = (await getItem('customer')) as object;
    const updatedCustomer = {
        ...customer,
        postal_code: postalCode
    };
    await setItem('customer', updatedCustomer);

    const insurances = ((await getItem('insurances')) ?? { WOON: {} }) as InsuranceLike;
    const address = insurances?.WOON?.address;
    await setItem('insurances', {
        ...insurances,
        WOON: {
            ...insurances.WOON,
            address: {
                ...address,
                postalCode,
                houseNumber
            },
            postal_code: postalCode,
            civic_number: houseNumber
        }
    });
};

const calculatePremium = async (info: AddressInfo, funnelUrl: string) => {
    await setAddressInfo(info);

    window.location.href = funnelUrl;
};

export { getAddressInfo, setAddressInfo, calculatePremium };
